// frontend/modules/customer-notification/routes.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import NotificationDashboardView from './views/NotificationDashboardView';
import NotificationHistoryView from './views/NotificationHistoryView';
import NotificationSchedulerView from './views/NotificationSchedulerView';
import NotificationTriggerView from './views/NotificationTriggerView';

export const notificationRoutes: RouteObject[] = [
    {
        path: '/notifications/dashboard',
        element: <NotificationDashboardView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/notifications/history',
        element: <NotificationHistoryView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/notifications/scheduler',
        element: <NotificationSchedulerView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/notifications/send',
        element: <NotificationTriggerView />,
        errorElement: <ErrorBoundary />
    }
];
